import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './components/Header10';
import Footer from './components/Footer10';
import ProductCard from './components/ProductCard';

const Shop10 = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');

    const categories = ['All', 'Sarees', 'Kurtas', 'Palazzos', 'Shirts', 'Anarkalis'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        { id: 1, name: 'Handwoven Cotton Saree', category: 'Sarees', price: 4990, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 2, name: 'Linen Kurta Set', category: 'Kurtas', price: 3490, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 3, name: 'Silk Blend Dupatta', category: 'Sarees', price: 2290, image: 'https://images.pexels.com/photos/2955819/pexels-photo-2955819.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 4, name: 'Block Print Palazzo', category: 'Palazzos', price: 2790, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 5, name: 'Organic Khadi Shirt', category: 'Shirts', price: 1990, image: 'https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 6, name: 'Chanderi Anarkali', category: 'Anarkalis', price: 5490, image: 'https://images.pexels.com/photos/4614070/pexels-photo-4614070.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 7, name: 'Tussar Silk Saree', category: 'Sarees', price: 6990, image: 'https://images.pexels.com/photos/2916387/pexels-photo-2916387.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 8, name: 'Cotton Mul Kurta', category: 'Kurtas', price: 2490, image: 'https://images.pexels.com/photos/3224610/pexels-photo-3224610.jpeg?auto=compress&cs=tinysrgb&w=400' },
        { id: 9, name: 'Ikat Print Palazzo', category: 'Palazzos', price: 1890, image: 'https://images.pexels.com/photos/2681751/pexels-photo-2681751.jpeg?auto=compress&cs=tinysrgb&w=400' },
    ];

    const filteredProducts = activeFilter === 'All'
        ? products
        : products.filter(p => p.category === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    return (
        <>
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap" rel="stylesheet" />

            <div style={{ fontFamily: "'Inter', sans-serif" }} className="min-h-screen bg-white">
                <Header />

                <main className="pt-16 md:pt-[72px]">
                    {/* Page Header */}
                    <div className="py-12 md:py-20 px-5 md:px-8 text-center" style={{ borderBottom: '1px solid #E7E5E4' }}>
                        <p className="text-[#A8A29E] text-[10px] md:text-xs tracking-[3px] uppercase mb-3">Collection</p>
                        <h1 className="text-2xl md:text-4xl font-light text-[#1C1917] tracking-tight">All Pieces</h1>
                    </div>

                    {/* Filters & Sort */}
                    <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-6 md:py-8">
                        {/* Mobile: horizontal scroll filter pills */}
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex overflow-x-auto gap-3 scrollbar-hide pb-1">
                                {categories.map((cat) => (
                                    <button
                                        key={cat}
                                        onClick={() => setActiveFilter(cat)}
                                        className={`flex-shrink-0 px-4 py-2 text-xs font-light tracking-wider uppercase transition-all duration-300 bg-transparent cursor-pointer ${
                                            activeFilter === cat
                                                ? 'text-[#1C1917] border-b border-[#1C1917]'
                                                : 'text-[#A8A29E] border-b border-transparent hover:text-[#78716C]'
                                        }`}
                                        style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}
                                    >
                                        {cat}
                                    </button>
                                ))}
                            </div>

                            <select
                                value={sortBy}
                                onChange={(e) => setSortBy(e.target.value)}
                                className="hidden md:block text-xs font-light text-[#78716C] bg-transparent border-none focus:outline-none cursor-pointer"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                {sortOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                            </select>
                        </div>

                        {/* Product Count */}
                        <p className="text-[#A8A29E] text-xs font-light mb-8">
                            {sortedProducts.length} {sortedProducts.length === 1 ? 'piece' : 'pieces'}
                        </p>

                        {/* Product Grid */}
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-x-6 md:gap-y-12">
                            {sortedProducts.map((product) => (
                                <ProductCard key={product.id} product={product} />
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Shop10;
